// import { rewardToWei } from "../../../utils"
import { Provider, utils, Wallet, Web3Provider } from "zksync-web3"
import { ethers } from "ethers"

const txObj = (address, args) => {
    args.from = address
    // gasPrice = (await avgGasPrice()) + 200000000000 // Added 200 gwei
    return args
}

// for contracts that use timestampLock send 0. For other contracts send null
const createIdea = async (web3, abi, ideaContractAddress, ownerAddress, name, description, image, setProcessing, setMessage, onSuccess) => {
    let ideaContract
    console.log("made it with: " + ownerAddress)
    // let stakingContract
    try {
        ideaContract = new web3.eth.Contract(abi, ideaContractAddress)
        // stakingContract = new web3.eth.Contract(pool.stakingAbi, pool.stakingContractAddress)
    } catch (error) {
        setMessage("error", "Error initializing contract")
        console.log(error)
    }

    if (ideaContract) {
        try {
            setProcessing(true)
            // let balanceInWei = await tokenContract.methods.balanceOf(ownerAddress).call()
            // let amountInWei = await web3.utils.toWei(currentPrice.toString(), "ether")
            // console.log("stake amount " + amountInWei)

            let args = { maxPriorityFeePerGas: 0, maxFeePerGas: 25000000 }

            await ideaContract.methods
                .createAnIdea(name, description, image) // This contract receives amount and timestamplock, 0 if there is no blocking time
                .send(txObj("0x8142409931f554d99013de129cdDc70EA016d62d", args))
                .on("receipt", function (receipt) {
                    if (receipt.status === true) {
                        //  setAllowance(allowance - amount)
                        setProcessing(false)
                        setMessage("success", `Idea added successfully`)
                        onSuccess()
                    } else {
                        setMessage("success", "dea added successfully")
                        setProcessing(false)
                    }
                })
                .on("error", function (error) {
                    setMessage("error", error.message)
                    setProcessing(false)
                })
            setProcessing(false)
        } catch (error) {
            console.log(error)
            setProcessing(false)
        }
    } else {
        setMessage("Uninitialized contracts")
    }
}

// for contracts that use timestampLock send 0. For other contracts send null
const createIdeaVia = async (
    web3,
    wallet,
    signer,
    abi,
    ideaContractAddress,
    paymasterAbi,
    paymasterContractAddress,
    ownerAddress,
    name,
    description,
    image,
    setProcessing,
    setMessage,
    onSuccess
) => {
    let ideaContract
    let paymasterContract

    // let stakingContract
    try {
        ideaContract = new ethers.Contract(ideaContractAddress, abi, signer)
        paymasterContract = new ethers.Contract(paymasterContractAddress, paymasterAbi, signer)
        // stakingContract = new web3.eth.Contract(pool.stakingAbi, pool.stakingContractAddress)
    } catch (error) {
        setMessage("error", "Error initializing contract")
        console.log(error)
    }

    if (ideaContract && paymasterContract) {
        try {
            setProcessing(true)
            const paymasterParams = utils.getPaymasterParams(paymasterContractAddress, {
                type: "General",
                innerInput: new Uint8Array()
            })
            console.log("paymaster params: " + JSON.stringify(paymasterParams))
            const gasLimit = await ideaContract.estimateGas.createAnIdea(name, description, image, {
                customData: {
                    gasPerPubData: utils.DEFAULT_GAS_PER_PUBDATA_LIMIT,
                    paymasterParams: paymasterParams
                }
            })
            console.log("gas limit: " + gasLimit)
            // let balanceInWei = await tokenContract.methods.balanceOf(ownerAddress).call()
            // let amountInWei = await web3.utils.toWei(currentPrice.toString(), "ether")
            // console.log("stake amount " + amountInWei)

            let args = { maxPriorityFeePerGas: 0, maxFeePerGas: 25000000 }
            await (
                await ideaContract.createAnIdea(name, description, image, {
                    customData: {
                        gasPerPubData: utils.DEFAULT_GAS_PER_PUBDATA_LIMIT,
                        paymasterParams: paymasterParams
                    }
                })
            )
                .wait()
                .then((receipt) => {
                    if (receipt.status === true) {
                        //  setAllowance(allowance - amount)
                        setProcessing(false)
                        setMessage("success", `Idea added successfully`)
                        onSuccess()
                    } else {
                        setMessage("error", "Whitelisting Fail")
                        setProcessing(false)
                    }
                })
                .on("error", function (error) {
                    setMessage("error", error.message)
                    setProcessing(false)
                })
            setProcessing(false)
        } catch (error) {
            console.log(error)
            setProcessing(false)
        }
    } else {
        setMessage("Uninitialized contracts")
    }
}

// // for contracts that use timestampLock send 0. For other contracts send null
// const unStakeNode = async (web3, pool, ownerAddress, tokenId, setProcessing, setMessage, onSuccess) => {
//     let tokenContract
//     let stakingContract
//     try {
//         stakingContract = new web3.eth.Contract(pool.stakingAbi, pool.stakingContractAddress)
//     } catch (error) {
//         setMessage("error", "Error initializing contract")
//         console.log(error)
//     }

//     if (tokenId && stakingContract) {
//         try {
//             setProcessing(true)

//                     await stakingContract.methods
//                         .burnNFT(tokenId) // This contract receives amount and timestamplock, 0 if there is no blocking time
//                         .send(txObj(ownerAddress, pool.args))
//                         .on("receipt", function (receipt) {
//                             if (receipt.status === true) {
//                                 //  setAllowance(allowance - amount)
//                                 setProcessing(false)
//                                 setMessage("success", `Node Unstaked Successfully`)
//                                 onSuccess()
//                             } else {
//                                 setMessage("error", "Unstaking Fail")
//                                 setProcessing(false)
//                             }
//                         })
//                         .on("error", function (error) {
//                             setMessage("error", error.message)
//                             setProcessing(false)
//                         })
//                     setProcessing(false)

//         } catch (error) {
//             console.log(error)
//             setProcessing(false)
//         }
//     } else {
//         setMessage("Uninitialized contracts")
//     }

// }

export { createIdea, createIdeaVia }
